import { LastState } from "./lastState.model";
import { isValidJson } from "../jsonUtil";
import { isCurrentRouteBlocked } from '../../auth/blocked-state-routes';


export default class LastStateService {
  [x: string]: any;

  static $inject = ['$localStorage', '$state', '$window', '$urlService'];

  constructor($localStorage, $state, $window, $urlService) {
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$window = $window;
    this.$urlService = $urlService;
  }

  get storage(): Storage {
    return window.sessionStorage
  }

  setLastState(href: string) {
    const url = new URL(href);
    if (!url.pathname || url.pathname === '/') {
      return;
    }
    const state = this.$urlService.match({path: url.pathname, search: url.search});
    const search = this.urlToSearchParamsObject(url);

    const lastState = state && {match: state.match, name: state.rule.state.name, search, href};

    this.storage.setItem("lastState", JSON.stringify(lastState) || href);
  }

  restoreLastState({defaultStateToGo, forceDefaultState = false}) {
    if (isCurrentRouteBlocked()) {
      return;
    }

    const lastState = this.storage.getItem('lastState');
    const {current} = this.$state;

    if (lastState) {
      this.clearLastState();
      this.redirectToLastState(lastState);
    } else if (forceDefaultState || (!current.name && !current.abstract)) {
      this.$state.go(defaultStateToGo);
    }
  }

  urlToSearchParamsObject(url: URL) {
    // @ts-ignore typescript strangely thinks that url.searchParams cannot be passed to Array.from
    return url.searchParams && Array.from(url.searchParams).reduce((acc, [k, v]) => ({...acc, [k]: v}), {})
  }

  clearLastState() {
    this.storage.removeItem('lastState');
  }

  private redirectToLastState(lastStateString: string) {
    if (!isValidJson(lastStateString)) {
      this.$window.location.assign(lastStateString);
      return
    }
    const lastState = JSON.parse(lastStateString) as LastState;
    if (lastState.search) // cannot $state.go to Angular2 route with query params
      this.$window.location.assign(lastState.href);
    else
      this.$state.go(lastState.name, lastState.match)
  }
}
